import React from "react";
import { useAnimation as UseAnimation, motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

import Image from "next/image";
import Link from "next/link";

import Comm01 from "@/public/static/images/comm-01.png";
import Comm02 from "@/public/static/images/comm-02.png";
import Comm03 from "@/public/static/images/comm-03.png";
import Comm04 from "@/public/static/images/comm-04.png";
import Comm05 from "@/public/static/images/comm-05.png";

function ecommerce() {
  const img: any = "/static/images/s-comm.png";

  const imgAnimation = UseAnimation();

  const handleMouseMove = (e: any) => {
    const { clientX, clientY } = e;
    const moveX = clientX - window.innerWidth / 2;
    const moveY = clientY - window.innerHeight / 2;
    const offsetFactor = 15;
    imgAnimation.start({
      x: moveX / offsetFactor,
      y: moveY / offsetFactor,
    });
  };

  return (
    <div className="wrapper">
      <Header />

      <section className="key_visual">
        <motion.img
          // animate={imgAnimation}
          // onMouseMove={(e) => handleMouseMove(e)}
          src={img}
          alt="Event Activation"
          loading="lazy"
        />
        <div className="img-bg" />
      </section>

      <section className="sv_content gray-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center Me0-heading-spr mb-3">
              <h1 className="mb-3 lh-1">
                In today's digital age, having an e-commerce platform is
                essential <br />
                for any business looking to stay competitive and expand its
                reach.
              </h1>
              <h1 className="lh-1">
                Here are what e-commerce provide benefits for your business.
              </h1>
            </div>
          </div>

          <div className="row justify-content-md-center mt-3">
            <div className="col-12 col-md-4 card-sv card-Me0">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <h1 className="card-title mb-3">
                    Convenience with
                    <br />
                    <span className="fw-bolder t-darkblue">
                      24/7 Availability
                    </span>
                  </h1>
                  <Image
                    loading="lazy"
                    src={Comm01}
                    alt="Convenience with 24/7 Availability"
                    className="img-fluid mx-auto mb-3 w-75"
                  />

                  <p className="mt-3">
                    E-commerce provides your customers with the convenience of
                    shopping from the comfort of their own home, avoiding the
                    hassle of travelling to physical stores. Online stores are
                    open 24/7, giving your customers the flexibility to shop at
                    any time of day.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-Me0">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <h1 className="card-title mb-3">
                    Increased{" "}
                    <span className="fw-bolder t-darkblue">
                      Brand Awareness
                    </span>{" "}
                    <br />
                    In a{" "}
                    <span className="fw-bolder t-darkblue">
                      Global-Reach
                    </span>{" "}
                    scale
                  </h1>
                  <Image
                    loading="lazy"
                    src={Comm02}
                    alt="Increased Brand Awareness In a Global-Reach scale"
                    className="img-fluid mx-auto mb-3 w-75"
                  />
                  <p className="mt-3">
                    E-commerce allows your businesses to reach customers all
                    over the world and reach customers who may not have
                    discovered yours. Let’s break down geographical barriers and
                    expand your customer base.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-Me0">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <h1 className="card-title mb-5">
                    Collect <span className="fw-bolder t-darkblue">Data</span>
                  </h1>
                  <Image
                    loading="lazy"
                    src={Comm03}
                    alt="Collect Data"
                    className="img-fluid mx-auto mb-3 w-75"
                  />
                  <p className="mt-3">
                    An e-commerce platform also offers your businesses the
                    opportunity to collect valuable data and get the insights on
                    your customers' preferences and behaviors, which can be used
                    to inform marketing and sales strategies.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-md-center mt-3">
            <div className="col-12 col-md-4 card-sv card-Me0">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <h1 className="card-title mb-3">
                    Increased{" "}
                    <span className="fw-bolder t-darkblue">Increased</span>
                  </h1>
                  <Image
                    loading="lazy"
                    src={Comm04}
                    alt="Increased Increased"
                    className="img-fluid mx-auto mb-3 w-75"
                  />
                  <p className="mt-3">
                    As e-commerce platforms allow the your business to collect
                    data and plan marketing strategy, together with greater
                    flexibility and convenience for both the business and its
                    customers, it enable transactions to occur at any time and
                    from anywhere in the world.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-Me0">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <h1 className="card-title mb-3">
                    <span className="fw-bolder t-darkblue">Cost-Effective</span>
                  </h1>
                  <Image
                    loading="lazy"
                    src={Comm05}
                    alt="Cost-Effective"
                    className="img-fluid mx-auto mb-3 w-75"
                  />
                  <p className="mt-3">
                    With e-commerce platforms, your business can automate
                    several aspects of the sales process, such as inventory
                    management, order processing, and payment collection. It
                    reduces the need for manual labor and minimizes operational
                    costs.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-12 text-center Me0-heading-spr mt-5">
              <h1 className="mb-3 lh-1">
                With ITP Asia, our one-stop service covers everything you need
                <br />
                to take your online business to the next level.
              </h1>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="d-flex box-media box-comm text-start justify-content-left align-items-center">
                <div className="num-tool-blue">
                  <span>1</span>
                </div>
                <h2 className="mb-0 t-white">
                  <span className="fw-bolder t-blue">PLAN </span> the marketing
                  strategy
                </h2>
                <div className="tool-list t-white ">
                  <p>
                    Our expert team can help you{" "}
                    <span className="fw-bolder t-blue">
                      develop a comprehensive marketing strategy tailored to
                      your e-commerce business{" "}
                    </span>
                    so you can be sure that your brand will be seen by the right
                    people, at the right time, and on the right platform.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="d-flex box-media box-comm text-start justify-content-left  align-items-center">
                <div className="num-tool-blue">
                  <span>2</span>
                </div>
                <h2 className="mb-0 t-white">
                  <span className="fw-bolder t-blue">PREPARE</span> the platform
                </h2>
                <div className="tool-list t-white ">
                  <p>
                    Whether you have an online store on{" "}
                    <span className="fw-bolder t-blue">
                      existing e-commerce
                    </span>
                    platforms or are in the process of{" "}
                    <span className="fw-bolder t-blue">
                      developing a new one
                    </span>
                    , we have the comprehensive experienced and support you need
                    to succeed.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="d-flex box-media box-comm text-start justify-content-left  align-items-center">
                <div className="num-tool-blue">
                  <span>3</span>
                </div>
                <h2 className="mb-0 t-white">
                  <span className="fw-bolder t-blue">SUPPORT </span> the
                  operation
                </h2>
                <div className="tool-list t-white ">
                  <p>
                    We provide comprehensive operational support for all aspects
                    of your e-commerce business. Whether it's{" "}
                    <span className="fw-bolder t-blue">
                      product preparation
                    </span>{" "}
                    for sales,{" "}
                    <span className="fw-bolder t-blue">
                      marketing campaigns, social advertising, warehouse and
                      logistics management, or product shipping,
                    </span>{" "}
                    we've got you covered.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="d-flex box-media box-comm text-start justify-content-left  align-items-center">
                <div className="num-tool-blue">
                  <span>4</span>
                </div>
                <h2 className="mb-0 t-white">
                  <span className="fw-bolder t-blue">REPORT </span> what you
                  need to know
                </h2>
                <div className="tool-list t-white ">
                  <p>
                    We provides{" "}
                    <span className="fw-bolder t-blue">
                      comprehensive business report,
                    </span>{" "}
                    where we analyze every aspect of your business, including
                    sales, financials, marketing, customer engagement, and other
                    relevant metrics to{" "}
                    <span className="fw-bolder t-blue">
                      create a customized business strategy
                    </span>{" "}
                    that aligns with your goals and objectives.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content blue-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center Me0-heading-spr mb-3">
              <h1 className="mb-4 lh-1 t-white">
                With our top-notch service, you can rest assured that your
                e-commerce business <br />
                will thrive in the competitive digital world.
              </h1>
              <h1 className="lh-1 t-white mb-0">
                Whether you're just starting out or looking to expand, we have
                the solution for you.
                <br />
                Contact us today to learn more about our e-commerce services.
              </h1>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default ecommerce;
